import { useTranslation } from 'react-i18next';
import { getSetting, getSettingLabel } from '@koob/utils';

const MEAL_KEYS = ['breakfast', 'lunch', 'dinner'];

export default function ExportDayProgram({
  program,
  startPosition,
  endPosition,
  settings,
}) {
  const { t } = useTranslation('trips');

  const daysSection = getSetting(settings, 'days');
  const programSubsection = getSetting(
    daysSection?.sections,
    'program-of-the-day',
  );
  const mealLabel = getSettingLabel(programSubsection?.fields, 'pod-meal');
  const routeLabel = getSettingLabel(programSubsection?.fields, 'pod-route');

  const start = startPosition ?? program?.startPosition;
  const end = endPosition ?? program?.endPosition;
  const startLabel = start?.name ?? start?.city;
  const endLabel = end?.name ?? end?.city;

  const includedMeals = MEAL_KEYS.filter((meal) =>
    program?.meals?.includes(meal),
  );

  const hasRoute = startLabel && endLabel;
  if (!hasRoute && includedMeals.length === 0) return null;

  return (
    <div
      className="flex flex-wrap items-stretch gap-x-6 gap-y-2 border-y border-k-gray/40 py-2"
      data-prevent-cut
    >
      {hasRoute && (
        <div>
          <div className="text-2xs font-bold uppercase tracking-wider text-[var(--td-ink-muted)]">
            {routeLabel}
          </div>
          <div className="text-xs leading-snug">
            {startLabel} → {endLabel}
          </div>
        </div>
      )}

      {includedMeals.length > 0 && (
        <div>
          <div className="text-2xs font-bold uppercase tracking-wider text-[var(--td-ink-muted)]">
            {mealLabel}
          </div>
          <div className="text-xs leading-snug">
            {includedMeals
              .map((meal) => t(`export.day.meals.${meal}`))
              .join(' · ')}
          </div>
        </div>
      )}
    </div>
  );
}
